import { AlertOctagon } from 'lucide-react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { env } from '@/app/config/env';
import { getErrorMessage } from '@/shared/api/api-error';

import { NotFoundPage } from './not-found-page';
import { StatusPage } from './status-page';

/**
 * The router's `errorElement`: catches anything thrown while rendering a route,
 * including lazy-chunk load failures.
 *
 * A failed chunk load usually means a new version was deployed while the tab
 * was open, so the offered action is a reload rather than a retry.
 */
export function RouteErrorPage() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <StatusPage
      icon={AlertOctagon}
      code={isRouteErrorResponse(error) ? String(error.status) : 'Error'}
      title="This page failed to load"
      description={
        env.isProduction
          ? 'Something went wrong while loading this page. Reloading usually fixes it — if it keeps happening, contact support.'
          : getErrorMessage(error)
      }
      actions={
        <>
          <Button size="sm" onClick={() => window.location.reload()}>
            Reload page
          </Button>
          <Button asChild variant="outline" size="sm">
            <a href="/dashboard">Back to dashboard</a>
          </Button>
        </>
      }
    />
  );
}
